<template>
    <div class="warning-modal">
        <div class="warning-header">
            Предупреждение
        </div>
        <div class="warning-content">
            <div class="warning-icon-wrapper">
                <question-circle-outlined class="warning-icon" />
            </div>
            <p class="warning-message">
                Вы уверены, что хотите выйти на указанном устройстве?
            </p>
        </div>
        <div class="warning-buttons">
            <a-button
                class="warning-btn warning-btn-yes"
                @click="onYesClick"
            >
                Да
            </a-button>
            <a-button
                class="warning-btn warning-btn-no"
                @click="onNoClick"
            >
                Нет
            </a-button>
        </div>
    </div>
</template>

<script>
import QuestionCircleOutlined from '@ant-design/icons-vue/QuestionCircleOutlined';
import { showErrorNotification } from '@/utils';

export default {
    name: 'SafetyWarning',
    components: {
        QuestionCircleOutlined,
    },
    props: {
        userId: {
            type: Number,
            required: true,
        },
        deviceId: {
            type: String,
            required: true,
        },
    },
    emits: ['close', 'table-update'],
    methods: {
        async onYesClick() {
            const hasInternet = await this.checkInternetConnection();
            if (hasInternet) {
                try {
                    await this.$http.delete(
                        `/user/${this.userId}/device/${this.deviceId}`,
                    );
                    this.$emit('table-update');
                    this.$emit('close');
                } catch (error) {
                    const errorMessage = error?.response?.data?.message
                        || error?.response?.data?.msg
                        || 'Ошибка сервера. Попробуйте позже';
                    showErrorNotification(errorMessage, 5000);
                }
            } else {
                showErrorNotification(
                    'Проверьте подключение к сети интернет',
                    5000,
                );
            }
        },
        onNoClick() {
            this.$emit('close');
        },
        async checkInternetConnection() {
            // Проверяем базовый статус подключения
            if (!navigator.onLine) {
                return false;
            }

            // Дополнительная проверка через попытку загрузить легковесный ресурс
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 5000);

                await fetch('https://www.google.com/favicon.ico', {
                    method: 'HEAD',
                    mode: 'no-cors',
                    cache: 'no-cache',
                    signal: controller.signal,
                });

                clearTimeout(timeoutId);
                return true;
            } catch (error) {
                return false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.warning-modal {
    width: max-content;
    background-color: #8dc07c;
    border-radius: 4px;
    overflow: hidden;
}

.warning-header {
    background-color: #8dc07c;
    color: #fff;
    text-align: left;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 500;
}

.warning-content {
    background-color: #fff;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.warning-icon-wrapper {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    background-color: #000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.warning-icon {
    font-size: 28px;
    color: #fff;
    display: block;
}

.warning-message {
    margin: 0;
    font-size: 18px;
    color: #000;
    text-align: left;
    line-height: 1.5;
    max-width: 300px;
    word-wrap: break-word;
}

.warning-buttons {
    background-color: #f5f5f5;
    padding: 12px;
    display: flex;
    flex-direction: row;
    gap: 12px;
    justify-content: end;
}

.warning-btn {
    min-width: 90px;
    height: 36px;
    border-radius: 4px;
    font-size: 14px;
    border: none;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.2s;
    background-color: #8dc07c;

    &:hover {
        background-color: #74b85d;
    }

    &:focus {
        outline: none;
    }
}
</style>
